import { GET_LIST, GET_FILE_TYPES } from "./action";

const initialState = {
  files: { totalRows: 0, items: [] },
  fileTypes: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST:
      return { ...state, files: action.payload };
    case GET_FILE_TYPES:
      return { ...state, fileTypes: action.payload };
    default:
      return state;
  }
};
